import { allowViewScreenings } from '../../../../../backend/features/permissions';
import { AuthError, defineView } from '@juvare/platform-app/App';
import { columns } from './types';
import { viewQuery } from './viewQuery';
export const jasBoardsStatusViewName = 'jasBoardsStatus';
export const jasBoardsStatusView = defineView({
    columns,
    viewQuery,
    orderByColumn: 'name',
    orderByDesc: true,
    onAuthList: (_appState, userState, response) => {
        if (!allowViewScreenings(userState)) {
            throw new AuthError('Unauthorized');
        }
        return response;
    },
});
